import { defineComponent as de, inject as K, toRef as E, ref as U, computed as j, watch as ue, openBlock as b, createElementBlock as f, normalizeClass as s, unref as e, createElementVNode as r, renderSlot as h, Fragment as ce, renderList as me, toDisplayString as N, createCommentVNode as S, createVNode as i, withCtx as D } from "vue";
import J from "./index592.js";
import { ElIcon as P } from "./index538.js";
import { DArrowLeft as z, DArrowRight as H } from "./index537.js";
import { isValidRange as pe, correctlyParseUserInput as be, getDefaultValue as fe } from "./index862.js";
import { panelMonthRangeEmits as ve, panelMonthRangeProps as ge } from "./index869.js";
import { useMonthRangeHeader as he } from "./index870.js";
import { useRangePicker as ke } from "./index867.js";
import { ROOT_PICKER_IS_DEFAULT_FORMAT_INJECTION_KEY as Ce } from "./index632.js";
import q from "./index864.js";
import { useLocale as ye } from "./index597.js";
import { PICKER_BASE_INJECTION_KEY as _e } from "./index579.js";
import { useFormDisabled as De } from "./index586.js";
const Pe = ["disabled", "onClick"], Re = ["disabled"], Ve = ["disabled"], we = ["disabled"], Ee = ["disabled"], R = "year";
var Ue = /* @__PURE__ */ de({
  name: "DatePickerMonthRange",
  __name: "panel-month-range",
  props: ge,
  emits: ve,
  setup(G, { emit: Q }) {
    const u = G, v = Q, { lang: k } = ye(), c = K(_e), W = K(
      Ce,
      void 0
    ), { shortcuts: I, disabledDate: Y, cellClassName: $ } = c.props, X = E(c.props, "format"), O = E(c.props, "defaultValue"), m = U(J().locale(k.value)), p = U(J().locale(k.value).add(1, R)), {
      minDate: C,
      maxDate: y,
      rangeState: V,
      ppNs: t,
      drpNs: g,
      handleChangeRange: A,
      handleRangeConfirm: Z,
      handleShortcutClick: ee,
      onSelect: w,
      parseValue: ae
    } = ke(u, {
      defaultValue: O,
      leftDate: m,
      rightDate: p,
      unit: R,
      sortDates: ie
    }), L = j(() => !!I.length), {
      leftPrevYear: B,
      rightNextYear: F,
      leftNextYear: M,
      rightPrevYear: T,
      leftLabel: te,
      rightLabel: ne,
      leftYear: le,
      rightYear: se
    } = he({
      unlinkPanels: E(u, "unlinkPanels"),
      leftDate: m,
      rightDate: p
    }), _ = j(() => u.unlinkPanels && se.value > le.value + 1), x = (a, l = !0) => {
      const n = a.minDate, d = a.maxDate;
      y.value === d && C.value === n || (v("calendar-change", [n.toDate(), d && d.toDate()]), y.value = d, C.value = n, l && Z());
    }, oe = () => {
      let a = null;
      c?.emptyValues && (a = c.emptyValues.valueOnClear.value), m.value = fe(e(O), {
        lang: e(k),
        unit: "year",
        unlinkPanels: u.unlinkPanels
      })[0], p.value = m.value.add(1, "year"), v("pick", a);
    }, re = (a) => be(
      a,
      X.value,
      k.value,
      W
    );
    function ie(a, l) {
      if (u.unlinkPanels && l) {
        const n = a?.year() || 0, d = l.year();
        p.value = n === d ? l.add(1, R) : l;
      } else
        p.value = m.value.add(1, R);
    }
    const o = De();
    return ue(
      () => u.visible,
      (a) => {
        !a && V.value.selecting && (ae(u.parsedValue), w(!1));
      }
    ), v("set-picker-option", ["isValidValue", pe]), v("set-picker-option", ["parseUserInput", re]), v("set-picker-option", ["handleClear", oe]), (a, l) => (b(), f(
      "div",
      {
        class: s([
          e(t).b(),
          e(g).b(),
          e(t).is("border", a.border),
          e(t).is("disabled", e(o)),
          {
            "has-sidebar": !!a.$slots.sidebar || L.value
          }
        ])
      },
      [
        r(
          "div",
          {
            class: s(e(t).e("body-wrapper"))
          },
          [
            h(a.$slots, "sidebar", {
              class: s(e(t).e("sidebar"))
            }),
            L.value ? (b(), f(
              "div",
              {
                key: 0,
                class: s(e(t).e("sidebar"))
              },
              [
                (b(!0), f(
                  ce,
                  null,
                  me(e(I), (n, d) => (b(), f("button", {
                    key: d,
                    type: "button",
                    class: s(e(t).e("shortcut")),
                    disabled: e(o),
                    onClick: (Ne) => e(ee)(n)
                  }, N(n.text), 11, Pe))),
                  128
                  /* KEYED_FRAGMENT */
                ))
              ],
              2
              /* CLASS */
            )) : S("v-if", !0),
            r(
              "div",
              {
                class: s(e(t).e("body"))
              },
              [
                r(
                  "div",
                  {
                    class: s([[e(t).e("content"), e(g).e("content")], "is-left"])
                  },
                  [
                    r(
                      "div",
                      {
                        class: s(e(g).e("header"))
                      },
                      [
                        r("button", {
                          type: "button",
                          class: s([e(t).e("icon-btn"), "d-arrow-left"]),
                          disabled: e(o),
                          onClick: l[0] || (l[0] = //@ts-ignore
                          (...n) => e(B) && e(B)(...n))
                        }, [
                          h(a.$slots, "prev-year", {}, () => [
                            i(e(P), null, {
                              default: D(() => [
                                i(e(z))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Re),
                        a.unlinkPanels ? (b(), f("button", {
                          key: 0,
                          type: "button",
                          disabled: !_.value || e(o),
                          class: s([[
                            e(t).e("icon-btn"),
                            e(t).is("disabled", !_.value || e(o))
                          ], "d-arrow-right"]),
                          onClick: l[1] || (l[1] = //@ts-ignore
                          (...n) => e(M) && e(M)(...n))
                        }, [
                          h(a.$slots, "next-year", {}, () => [
                            i(e(P), null, {
                              default: D(() => [
                                i(e(H))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Ve)) : S("v-if", !0),
                        r(
                          "div",
                          null,
                          N(e(te)),
                          1
                          /* TEXT */
                        )
                      ],
                      2
                      /* CLASS */
                    ),
                    i(q, {
                      "selection-mode": "range",
                      date: m.value,
                      "min-date": e(C),
                      "max-date": e(y),
                      "range-state": e(V),
                      "disabled-date": e(Y),
                      disabled: e(o),
                      "cell-class-name": e($),
                      onChangerange: e(A),
                      onPick: x,
                      onSelect: e(w)
                    }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "disabled", "cell-class-name", "onChangerange", "onSelect"])
                  ],
                  2
                  /* CLASS */
                ),
                r(
                  "div",
                  {
                    class: s([[e(t).e("content"), e(g).e("content")], "is-right"])
                  },
                  [
                    r(
                      "div",
                      {
                        class: s(e(g).e("header"))
                      },
                      [
                        a.unlinkPanels ? (b(), f("button", {
                          key: 0,
                          type: "button",
                          disabled: !_.value || e(o),
                          class: s([[
                            e(t).e("icon-btn"),
                            e(t).is("disabled", !_.value || e(o))
                          ], "d-arrow-left"]),
                          onClick: l[2] || (l[2] = //@ts-ignore
                          (...n) => e(T) && e(T)(...n))
                        }, [
                          h(a.$slots, "prev-year", {}, () => [
                            i(e(P), null, {
                              default: D(() => [
                                i(e(z))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, we)) : S("v-if", !0),
                        r("button", {
                          type: "button",
                          class: s([e(t).e("icon-btn"), "d-arrow-right"]),
                          disabled: e(o),
                          onClick: l[3] || (l[3] = //@ts-ignore
                          (...n) => e(F) && e(F)(...n))
                        }, [
                          h(a.$slots, "next-year", {}, () => [
                            i(e(P), null, {
                              default: D(() => [
                                i(e(H))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Ee),
                        r(
                          "div",
                          null,
                          N(e(ne)),
                          1
                          /* TEXT */
                        )
                      ],
                      2
                      /* CLASS */
                    ),
                    i(q, {
                      "selection-mode": "range",
                      date: p.value,
                      "min-date": e(C),
                      "max-date": e(y),
                      "range-state": e(V),
                      "disabled-date": e(Y),
                      disabled: e(o),
                      "cell-class-name": e($),
                      onChangerange: e(A),
                      onPick: x,
                      onSelect: e(w)
                    }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "disabled", "cell-class-name", "onChangerange", "onSelect"])
                  ],
                  2
                  /* CLASS */
                )
              ],
              2
              /* CLASS */
            )
          ],
          2
          /* CLASS */
        )
      ],
      2
      /* CLASS */
    ));
  }
});
export {
  Ue as default
};
